// extracted by mini-css-extract-plugin
module.exports = {"body":"BodyParser_body__GrGC_"};